import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../views/icons/Air8ChatBotLogoEnter.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "freshchat"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "freshchat"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import { onMounted, onUnmounted, computed, watch } from 'vue'
import $ from 'jquery'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { destoryChatbot, showChatbot } from './service'
import { useDevice } from '@/views/pages/chatbot/hooks/useDevice'
import _ from 'lodash'
import { convertColumnValue } from '@/api/commonService'


export default /*#__PURE__*/_defineComponent({
  props: {
    type: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as {
  type: 'chatbot' | 'freshchat'
}
const store = useStore()
const router = useRouter()
const { isMobileDevice, isQuark, isHuaweiBrowser } = useDevice()
const lang = computed(() => (store.state as any)?.app?.locale?.lang || 'en')



const _type = computed(() => props.type || 'chatbot')
const _showFreshchatRelated = computed(() => _type.value === 'freshchat')
const _showOpenWhatsApp = computed(() => isMobileDevice.value && !isQuark && !isHuaweiBrowser)

const _loadFreshchat = () => {
  if (_showFreshchatRelated.value && !_showOpenWhatsApp.value && isShowAnyChat.value) {
    showChatbot('chatbot', { language: lang, store })
  }
}

const handleResize = () => {
  if (_showFreshchatRelated.value && !_showOpenWhatsApp.value && isShowAnyChat.value) {
    _loadFreshchat()
  } else {
    destoryChatbot()
  }
}

onMounted(() => {
  // TODO: 临时关闭
  _loadFreshchat()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  destoryChatbot()
})

const handleClickToWhatsApp = () => {
  const whatsapp_business_number = process.env.VUE_APP_WHATSAPP_BUSINESS_NUMBER
  if (!whatsapp_business_number) {
    return
  }

  window.open(`https://wa.me/${whatsapp_business_number}`, '_blank')
}

const handleClick = () => {
  router.push('/buyer-outlook')
}

const isInUnshowPage = computed(() => {
  const _path = router.currentRoute.value.path
  return _path.includes('/buyer-outlook') || _path.includes('/notice')
})

const isShowAnyChat = computed(() => {
  const path = router.currentRoute.value.path
  if (_.includes(path, '/channel-partner')) return false
  if (_.includes(path, '/dashboard/ct')) return false
  return true
})

return (_ctx: any,_cache: any) => {
  return (_unref(isShowAnyChat))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(_showFreshchatRelated) && !_unref(_showOpenWhatsApp))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        (_unref(_showFreshchatRelated) && _unref(_showOpenWhatsApp))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(_ctx.$style['mock-freshchat-container']),
              onClick: handleClickToWhatsApp
            }, _hoisted_4, 2))
          : _createCommentVNode("", true),
        (!_unref(isInUnshowPage) && _unref(_type) === 'chatbot')
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(_ctx.$style['mock-freshchat-container']),
              onClick: handleClick
            }, _hoisted_6, 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})